import { useEffect } from "react";

const ALLOWED_HOSTNAMES = ["muzukuru.com", "www.muzukuru.com"];

const TawkChat = () => {
  useEffect(() => {
    if (!ALLOWED_HOSTNAMES.includes(window.location.hostname)) return;

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = "https://embed.tawk.to/6955464a1c19251982ae9a1d/1jdqhl53c";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");

    const s0 = document.getElementsByTagName("script")[0];
    s0.parentNode?.insertBefore(s1, s0);

    return () => {
      s1.parentNode?.removeChild(s1);
    };
  }, []);

  return null;
};

export default TawkChat;
